import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  return (
    <div>
      {/* HERO */}
      <div className="shell">
        <section className="hero">
          <div>
            <span className="eyebrow">Toskania · od 2014</span>
            <h1 className="display hero-headline">
              Dom wśród<br />
              <em>cyprysów</em><br />
              i oliwek.
            </h1>
            <p className="hero-lede">
              Kamienna willa w sercu Toskanii — miejsce dla przyjaciół, rodzinnych stołów i długich
              popołudni nad basenem. Sześć sypialni, winnica za oknem, Florencja pół godziny drogi.
            </p>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <button className="btn btn-primary" onClick={() => navigate('/availability')}>
                Zobacz dostępność →
              </button>
              <button className="btn btn-ghost" onClick={() => navigate('/bedrooms')}>
                Sypialnie
              </button>
            </div>
            <dl className="hero-meta">
              <div><dt>Goście</dt><dd>do 12 osób</dd></div>
              <div><dt>Sypialnie</dt><dd>6</dd></div>
              <div><dt>Powierzchnia</dt><dd>300 m²</dd></div>
            </dl>
          </div>
          <img
            src="/photos/toskania/image_27.jpg"
            alt="Willa Toskania"
            className="hero-image"
            style={{ borderRadius: 2 }}
          />
        </section>
      </div>

      {/* EDITORIAL QUOTE */}
      <div className="shell">
        <section className="section" style={{ paddingTop: 40, paddingBottom: 40 }}>
          <div className="divider"><span className="divider-glyph">✦</span></div>
          <p
            className="display-italic"
            style={{
              fontSize: 'clamp(28px, 3.6vw, 44px)',
              maxWidth: 900, margin: '0 auto', textAlign: 'center',
              lineHeight: 1.25, color: 'var(--ink-soft)'
            }}
          >
            „Rano światło wchodzi przez okiennice, pachnie rozmarynem z ogrodu.
            Kawę pijemy na tarasie, patrząc, jak mgła schodzi z doliny."
          </p>
          <div className="divider" style={{ marginTop: 28 }}>
            <span className="small-caps olive">notatka gospodarzy</span>
          </div>
        </section>
      </div>

      {/* ASYMMETRIC IMAGE GRID */}
      <div className="shell">
        <section className="section">
          <div className="section-head">
            <div>
              <span className="eyebrow">Dom</span>
              <h2 className="display section-title">
                Kamień, drewno,<br /><em>światło</em>.
              </h2>
            </div>
            <p className="section-lede">
              Dom odrestaurowany z szacunkiem dla oryginalnych belek stropowych,
              kamiennej posadzki i kominka, przy którym zimą czyta się książki.
            </p>
          </div>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1.2fr 1fr 1fr',
            gridTemplateRows: 'repeat(2, 280px)',
            gap: 16,
          }}>
            <img src="/photos/toskania/image_2.jpg" alt="Salon z kominkiem"
              style={{ gridRow: 'span 2', objectFit: 'cover', width: '100%', height: '100%' }} />
            <img src="/photos/toskania/image_3.jpg" alt="Kuchnia"
              style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
            <img src="/photos/toskania/image_4.jpg" alt="Taras"
              style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
            <img src="/photos/toskania/image_5.jpg" alt="Basen"
              style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
            <img src="/photos/toskania/image_6.jpg" alt="Winnica"
              style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
          </div>
        </section>
      </div>

      {/* THREE COLUMN FEATURES */}
      <div style={{ background: 'var(--cream-2)' }}>
        <div className="shell">
          <section className="section">
            <div
              style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 56 }}
              className="features-grid"
            >
              {[
                {
                  n: '01', t: 'Dla przyjaciół',
                  d: 'Willa wynajmowana wyłącznie osobom, które znamy osobiście. Bez portali, bez pośredników — rezerwacja bezpośrednio u nas.'
                },
                {
                  n: '02', t: 'Pełne wyposażenie',
                  d: 'Basen 11×4 m, kort tenisowy, kuchnia z piecem chlebowym, sześć sypialni z łazienkami, rowery, trampolina i wiele więcej.'
                },
                {
                  n: '03', t: 'Serce Toskanii',
                  d: '30 minut do Pizy, Florencji i piaszczystej plaży. W zimie godzina i pół do ośrodka narciarskiego z 80 km tras.'
                },
              ].map(f => (
                <div key={f.n}>
                  <div className="mono olive" style={{ marginBottom: 14 }}>{f.n} / 03</div>
                  <h3 className="display" style={{ fontSize: 32, margin: '0 0 14px' }}>{f.t}</h3>
                  <p style={{ margin: 0, color: 'var(--ink-soft)', fontSize: 15, lineHeight: 1.6 }}>{f.d}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>

      {/* VIDEO */}
      <div className="shell">
        <section className="section">
          <div
            style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: 48, alignItems: 'center' }}
            className="video-block"
          >
            <div>
              <span className="eyebrow">Film</span>
              <h2 className="display section-title" style={{ fontSize: 'clamp(32px, 4vw, 56px)' }}>
                Popołudnie<br /><em>w Toskanii</em>.
              </h2>
              <p style={{ color: 'var(--ink-soft)', margin: '20px 0 0' }}>
                Krótki film z okolic willi — krajobraz, drogi i doliny, które otaczają dom na co dzień.
              </p>
            </div>
            <div style={{ aspectRatio: '16/9', overflow: 'hidden', background: 'var(--cream-3)' }}>
              <iframe
                style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
                src="https://www.youtube.com/embed/o7-ZtyjLLWc?rel=0&color=white&controls=1"
                allowFullScreen
                title="Willa Toskania — film"
              />
            </div>
          </div>
        </section>
      </div>

      {/* ATRAKCJE */}
      <div style={{ background: 'var(--cream-2)' }}>
        <div className="shell">
          <section className="section">
            <div className="section-head">
              <div>
                <span className="eyebrow">Atrakcje</span>
                <h2 className="display section-title">Co tu <em>robić</em>.</h2>
              </div>
              <p className="section-lede">
                Willa oferuje własne atrakcje — nie trzeba wyjeżdżać, żeby się dobrze bawić.
              </p>
            </div>
            <div
              style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 0 }}
              className="amen-grid"
            >
              {[
                'Własny kort tenisowy', 'Basen 11×4 m', 'Tenis stołowy', 'Koszykówka',
                'Trampolina', 'Grill gazowy', 'Piec do pizzy', 'Maszyna do chleba',
                'Rzutki', 'Huśtawki', 'Trekking w okolicy', 'PS4',
              ].map(a => (
                <div key={a} style={{
                  borderTop: '1px solid var(--ink)', paddingTop: 14, paddingBottom: 14,
                  paddingRight: 16,
                  display: 'flex', justifyContent: 'space-between', alignItems: 'baseline'
                }}>
                  <span style={{ fontSize: 14 }}>{a}</span>
                  <span className="mono olive">✦</span>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>

      {/* FOR FRIENDS */}
      <div style={{ background: 'var(--olive)', color: 'var(--cream)' }}>
        <div className="shell">
          <section className="section" style={{ textAlign: 'center' }}>
            <span className="eyebrow" style={{ color: 'rgba(245,239,228,0.7)' }}>Dla przyjaciół</span>
            <h2
              className="display"
              style={{
                fontSize: 'clamp(36px, 5vw, 64px)', margin: '12px 0 22px',
                color: 'var(--cream)', lineHeight: 1.1
              }}
            >
              Willa jest domem, <em>nie hotelem</em>.
            </h2>
            <p style={{
              maxWidth: 640, margin: '0 auto 28px',
              color: 'rgba(245,239,228,0.85)', fontSize: 17, lineHeight: 1.6
            }}>
              Gościmy wyłącznie przyjaciół i ich rodziny. Jeśli trafiłeś na tę stronę,
              napisz do nas — chętnie opowiemy o domu i sprawdzimy dostępność.
            </p>
            <button
              className="btn btn-ghost"
              style={{ color: 'var(--cream)', borderColor: 'var(--cream)' }}
              onClick={() => navigate('/contact')}
            >
              Napisz do nas →
            </button>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Home;
